<template>
  <a-card>
    <template slot="title" style="padding:0px!important">
      <div>
        <div class="ant-card-head-wrapper">
          <div class="ant-card-head-title" style="padding:0px!important">
            <a-icon type="pic-center" />
            &nbsp;&nbsp;Log Kehadiran Karyawan
          </div>
        </div>
      </div>
    </template>
    <div slot="extra" style="display:flex;align-items: center;">
      <span style="padding-right:5px">Periode : </span><a-month-picker v-model="f_date" :allowClear="false"
        @change="f_dateChange" style="float:right;width:100px" />
      <div style="display:flex;align-items: center;"
        v-if="$route.meta.isHRD || $route.meta.isAL || $route.meta.isDirektur">
        <span style="padding-left:10px;padding-right:5px">&nbsp;TLC : </span>
        <a-select v-model="f_tlc" show-search style="min-width:200px" v-if="$route.meta.isHRD"
          placeholder="Pilih TLC karyawan" :filterOption="optionFilter" @change="f_dateChange">
          <a-select-option v-for="item in getKaryawan" :key="item.tlc">{{
            item.tlc + " - " + item.nama
          }}</a-select-option>
        </a-select>
        <a-select v-model="f_tlc" show-search style="min-width:200px" v-else placeholder="Pilih TLC karyawan"
          :filterOption="optionFilter" @change="f_dateChange">
          <a-select-option v-for="item in getKaryawanBawahan" :key="item.tlc">{{
            item.tlc + " - " + item.nama
          }}</a-select-option>
        </a-select>
      </div>
    </div>
    <div class="act-grid">
      <a-row align="bottom" :gutter="{ xs: 0, lg: 8 }" v-if="isMobile">
        <a-row :gutter="24">
          <a-col :xs="{ span: 14 }" :lg="{ span: 14 }">
            <div style="font-weight:bold">TARGET JAM KERJA</div>
          </a-col>
          <a-col :xs="{ span: 10 }" :lg="{ span: 10 }">
            : {{ jam_kerja.total_jam }}
          </a-col>
        </a-row>
        <a-row :gutter="24">
          <a-col :xs="{ span: 14 }" :lg="{ span: 14 }">
            <div style="font-weight:bold">REALISASI JAM KERJA</div>
          </a-col>
          <a-col :xs="{ span: 10 }" :lg="{ span: 10 }">
            : {{ jam_kerja.log_jam }}
          </a-col>
        </a-row>
        <a-row :gutter="24">
          <a-col :xs="{ span: 14 }" :lg="{ span: 14 }">
            <div style="font-weight:bold">KEKURANGAN JAM KERJA</div>
          </a-col>
          <a-col :xs="{ span: 10 }" :lg="{ span: 10 }">
            : {{ jam_kerja.krg_jam }}
          </a-col>
        </a-row>
        <a-row :gutter="24">
          <a-col :xs="{ span: 14 }" :lg="{ span: 14 }">
            <div style="font-weight:bold">TOTAL HARI KERJA</div>
          </a-col>
          <a-col :xs="{ span: 10 }" :lg="{ span: 10 }">
            : {{ jam_kerja.hari_kerja }}
          </a-col>
        </a-row>
        <a-row :gutter="24">
          <a-col :xs="{ span: 14 }" :lg="{ span: 14 }">
            <div style="font-weight:bold">TOTAL HARI IZIN</div>
          </a-col>
          <a-col :xs="{ span: 10 }" :lg="{ span: 10 }">
            : {{ jam_kerja.ijin }}
          </a-col>
        </a-row>
        <a-row :gutter="24">
          <a-col :xs="{ span: 14 }" :lg="{ span: 14 }">
            <div style="font-weight:bold">TOTAL HARI CUTI</div>
          </a-col>
          <a-col :xs="{ span: 10 }" :lg="{ span: 10 }">
            : {{ jam_kerja.cuti }}
          </a-col>
        </a-row>
      </a-row>
      <a-row type="flex" align="bottom" :gutter="{ xs: 0, lg: 8 }" v-else>
        <a-col :xs="24" :lg="24">
          <a-row>
            <a-col :xs="{ span: 24 }" :lg="{ span: 7 }">
              <div style="font-weight:bold">TARGET JAM KERJA</div>
            </a-col>
            <a-col :xs="{ span: 24 }" :lg="{ span: 5 }">
              <div style="font-weight:bold">: {{ jam_kerja.total_jam }}</div>
            </a-col>
            <a-col :xs="{ span: 24 }" :lg="{ span: 7 }">
              <div style="font-weight:bold">TOTAL HARI KERJA</div>
            </a-col>
            <a-col :xs="{ span: 24 }" :lg="{ span: 5 }">
              <div style="font-weight:bold">: {{ jam_kerja.hari_kerja }}</div>
            </a-col>
          </a-row>
          <a-row>
            <a-col :xs="{ span: 24 }" :lg="{ span: 7 }">
              <div style="font-weight:bold">REALISASI JAM KERJA</div>
            </a-col>
            <a-col :xs="{ span: 24 }" :lg="{ span: 5 }">
              <div style="font-weight:bold">: {{ jam_kerja.log_jam }}</div>
            </a-col>
            <a-col :xs="{ span: 24 }" :lg="{ span: 7 }">
              <div style="font-weight:bold">TOTAL HARI IZIN</div>
            </a-col>
            <a-col :xs="{ span: 24 }" :lg="{ span: 5 }">
              <div style="font-weight:bold">: {{ jam_kerja.ijin }}</div>
            </a-col>
          </a-row>
          <a-row>
            <a-col :xs="{ span: 24 }" :lg="{ span: 7 }">
              <div style="font-weight:bold">KEKURANGAN JAM KERJA</div>
            </a-col>
            <a-col :xs="{ span: 24 }" :lg="{ span: 5 }">
              <div style="font-weight:bold">: {{ jam_kerja.krg_jam }}</div>
            </a-col>
            <a-col :xs="{ span: 24 }" :lg="{ span: 7 }">
              <div style="font-weight:bold">TOTAL HARI CUTI</div>
            </a-col>
            <a-col :xs="{ span: 24 }" :lg="{ span: 5 }">
              <div style="font-weight:bold">: {{ jam_kerja.cuti }}</div>
            </a-col>
          </a-row>
          <!-- <a-select :hidden="true" v-model="f_jns" show-search :class="isMobile ? 'w-full m-top m-right' : 'm-right'"
              placeholder="Pilih Kategori" :filterOption="optionFilter" @change="kategoriChange">
              <a-select-option key="1" value="1">Telah Sidik Jari</a-select-option>
              <a-select-option key="2" value="2">Belum Sidik Jari</a-select-option>
            </a-select> -->
          <!-- <a-button :hidden="true" type="primary" @click="handleExport">Export</a-button> -->
        </a-col>
        <a-col :xs="24" :lg="8">
          <!-- <a-month-picker v-model="f_date" :allowClear="false" @change="f_dateChange" style="float:right;width:100px"/> -->
        </a-col>
      </a-row>
      <!-- <a-row :gutter="{ xs: 0, lg: 8 }" >
        <a-col :xs="24" :lg="24">
          <div :class="isMobile ? 'content-filter' : 'd-flex justify-start content-filter'">
            
          </div>
        </a-col>
      </a-row> -->
    </div>
    <a-table :columns="columns" :data-source="datalist" bordered :pagination="pagination" :scroll="{ x: 1200, y: 500 }"
      :loading="loading.table" size="small" key="tblMonitoring" :rowKey="(record, index) => { return index; }"
      :rowClassName="(record, index) => getStyleRow(record.keterangan_sistem != null ? record.keterangan_sistem : '', record.status, record)">
      <span slot="customTitle">Nama Karyawan</span>
      <template slot="tgl" slot-scope="value, item">
        {{ item.hari }}, {{ moment(item.tgl, "YYYY-MM-DD").format(getDefaultDateFormat) }}
      </template>
      <!-- <template slot="name" slot-scope="value, item">
        <span>({{ item.tlc }}) {{item.nama}}</span>
      </template> -->
      <span slot="no" slot-scope="value, item, index">
        {{ (pagination.page - 1) * pagination.pageSize + (index + 1) }}
      </span>
      <span slot="check_in" slot-scope="value">
        {{ value.check_in }}
        <span v-if="value.foto_check_in" style="padding-left:1px;padding-right:5px;">&nbsp;&nbsp;&nbsp;<a-icon
            @click="viewPhoto(value.foto_check_in, value.note_check_in)" type="camera" /></span>
        <span v-if="value.latitude_check_in" style="padding-right:5px;">&nbsp;&nbsp;&nbsp;<a-icon
            @click="viewGoogleMaps(value.latitude_check_in, value.longitude_check_in)" type="environment" /></span>
      </span>
      <span slot="check_out" slot-scope="value">
        {{ value.check_out }}
        <span v-if="value.foto_check_out" style="padding-left:1px;padding-right:5px;">&nbsp;&nbsp;&nbsp;<a-icon
            @click="viewPhoto(value.foto_check_out, value.note_check_out)" type="camera" /></span>
        <span v-if="value.latitude_check_out" style="padding-right:5px;">&nbsp;&nbsp;&nbsp;<a-icon
            @click="viewGoogleMaps(value.latitude_check_out, value.longitude_check_out)" type="environment" /></span>
      </span>
      <span slot="tags" slot-scope="tags">
        <a-tag v-for="tag in tags" :key="tag"
          :color="tag === 'loser' ? 'volcano' : tag.length > 5 ? 'geekblue' : 'green'">
          {{ tag.toUpperCase() }}
        </a-tag>
      </span>
      <span slot="keterangan" slot-scope="text, record">
        <table>
          <tr>
            <!-- <td style="width:40px" v-if="record.tgl==moment().format('YYYY-MM-DD') && !record.status_hrd">
              <a-button type="link" class="m-right" size="small"  @click="handleModalKet(record)"><a-icon type="edit"/></a-button> 
            </td> -->
            <td>
              <span v-if="record.keterangan_sistem">{{ record.keterangan_sistem }}<br /></span>
              <b v-if="record.jenis_keterangan">{{ record.jenis_keterangan }}</b>
              <span v-if="record.keterangan_ijin">
                <br />Ket : {{ record.keterangan_ijin }}
                <a-button v-if="record.path_file" type="link" shape="circle" icon="file" size="small" class="raise"
                  @click="handleshowFile(record.path_file)" />
                <br />
              </span>
              <span v-if="record.status_hrd">
                HRD: {{ record.keterangan_hrd }}<br />
                <a-tag :color="record.status_hrd == 'Approved_without_deduction' ? 'green' : 'red'">
                  {{ record.status_hrd == 'Approved_without_deduction'
                    ? 'Approved Tanpa Potongan'
                    : 'Approved Dengan Potongan' }}
                </a-tag>
              </span>
              <a-button v-if="record.url" type="link" class="m-left" size="small"
                @click="handleViewfile(record.url)"><a-icon type="file" /></a-button>
            </td>
          </tr>
        </table>
      </span>
      <div slot="action" slot-scope="value, item">
        <a-button type="link" shape="circle" icon="history" size="small" class="raise" @click="handleshowModal(item)" />
        <a-button type="link" v-if="item.entriable_ket == '1' && !item.status_hrd && !$route.meta.isHRD" class="m-right"
          size="small" @click="handleModalKet(item)"><a-icon type="edit" /></a-button>
      </div>
    </a-table>
    <!-- div berikut untuk kebutuhan export data -->
    <div class="contentTable">
      <a-table :columns="columns" :data-source="datalist_origin" bordered :pagination="false" :scroll="{ x: 1200 }"
        :loading="loading.table" size="small" key="tblMonitoring" :rowKey="(record, index) => { return index; }"
        :rowClassName="(record, index) => getStyleRow(record.keterangan_sistem != null ? record.keterangan_sistem : '', record.status, record)">
        <span slot="customTitle">Nama Karyawan</span>
        <template slot="tgl" slot-scope="value, item">
          {{ moment(item.tgl, "YYYY-MM-DD").format(getDefaultDateFormat) }}
        </template>
        <template slot="name" slot-scope="value, item">
          <a-button type="link" shape="circle" icon="container" size="small" />
          ({{ item.tlc }}) {{ item.nama }}
        </template>
        <span slot="no" slot-scope="value, item, index">
          {{ (pagination.page - 1) * pagination.pageSize + (index + 1) }}
        </span>
        <span slot="tags" slot-scope="tags">
          <a-tag v-for="tag in tags" :key="tag"
            :color="tag === 'loser' ? 'volcano' : tag.length > 5 ? 'geekblue' : 'green'">
            {{ tag.toUpperCase() }}
          </a-tag>
        </span>
        <span slot="keterangan" slot-scope="text, record">
          {{ record.jenis_keterangan }} {{ record.keterangan_sistem }} {{ record.keterangan_ijin }}
          <span v-if="record.keterangan_ijin"><br />{{ record.keterangan_ijin }}</span>
        </span>
      </a-table>
    </div>


    <a-modal v-model="modal.visible" centered :maskClosable="false" :footer="false" :width="isMobile ? '100%' : '70%'"
      @cancel="handleCloseModalHist">
      <template slot="title">
        <h3>Detail Log. Absensi</h3>
        {{ modal.title }}
      </template>
      <a-row :gutter="16" v-if="$route.meta.isHRD">
        <a-form-model ref="forms" :model="formAbs" :rules="rulesAbs" :style="isMobile ? 'display: flex;flex-direction: column;' : 'display: flex;'">
          <a-col :xs="24" :lg="6">
            <a-form-model-item label="Sumber" prop="sumber">
              <a-select placeholder="Pilih Jenis Keterangan" v-model="formAbs.sumber" class="w-full" disabled>
                <a-select-option value="Aplikasi Harmoni">Aplikasi Harmoni</a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
          <a-col :xs="24" :lg="3">
            <a-form-model-item label="Log Time" prop="logTime">
              <a-time-picker v-model="formAbs.logDay" hidden/> 
              <a-time-picker v-model="formAbs.logTime" format="HH:mm" placeholder="Log Time" :allow-clear="false" class="w-full" />  
            </a-form-model-item>
          </a-col>
          <a-col :xs="24" :lg="12">
            <a-form-model-item label="Keterangan" prop="desc">
              <a-input v-model="formAbs.tlc" hidden/>
              <a-input v-model="formAbs.desc" />
            </a-form-model-item>
          </a-col>
          <a-col :xs="24" :lg="3" style="flex: 1;align-content: flex-end;padding-bottom: 8px;">
            <a-button
              type="primary"
              icon="save"
              @click="addLog"
              :loading="loading.add"
              >Tambahkan</a-button
            >
          </a-col>
        </a-form-model>
      </a-row>
      <a-table key="tbllog" :columns="columnsDtlLog" :data-source="modal.datalist" :loading="modal.loading"
        :scroll="{ x: 800, y: 300 }" :rowKey="(record, index) => { return index; }" size="small" bordered :class="isMobile?'margin-top':''">
        <span slot="dtlno" slot-scope="value, item, index">
          {{ (index + 1) }}
        </span>
        <span slot="sumber" slot-scope="value, item">
          <b>{{ item.machine }}</b>
          <div v-if="item.divice_nm">
            {{ item.divice_nm }}
          </div>
          <div v-if="item.latitude">
            <b>lat :</b> {{ item.latitude }}
          </div>
          <div v-if="item.longitude">
            <b>Long :</b> {{ item.longitude }}
          </div>
          <div v-if="item.latitude && item.longitude">
            <b>Photo</b> ( <a v-if="item.file_url" style="padding-left:1px;padding-right:5px;"
              class="bob-on-hover">&nbsp;&nbsp;&nbsp;<a-icon @click="handleViewfile(value.file_url)" type="camera" /></a>)
            ,&nbsp;<b>Maps</b> ( <a v-if="item.latitude" style="padding-right:5px;"
              class="bob-on-hover">&nbsp;&nbsp;&nbsp;<a-icon @click="viewGoogleMaps(item.latitude, item.longitude)"
                type="environment" /></a>)
          </div>
          <!-- <div v-if="item.divice_nm">
            <b>Keterangan :</b> {{ item.note }}
          </div> -->
        </span>
        <span slot="ket" slot-scope="value, item">
          {{ item.note }}
        </span>
        <span slot="log" slot-scope="value, item">
          {{ item.log_dtl }}
        </span>
        <template slot="footer">
          <b>Total Jam Kerja : {{ modal.total_jam }}</b>
        </template>
      </a-table>
    </a-modal>

    <a-modal v-if="modal2.visible" v-model="modal2.visible" centered :maskClosable="false" @cancel="handleCancelModalKet"
      :confirmLoading="modal2.loading" @ok="handlePerijinan">
      <template slot="title">
        <h3>Buat Keterangan</h3>
      </template>
      <a-form :form="formKet">
        <a-form-item label="Jenis">
          <a-select placeholder="Pilih Jenis Keterangan" v-decorator="[
            'jenis',
            {
              rules: [{ required: true }], initialValue: modal2.form.jenis,
            },
          ]" class="w-full" @change="HandleChangeJenis">
            <a-select-option value="Ijin Terlambat">Ijin Terlambat</a-select-option>
            <a-select-option value="Ijin Pulang Awal">Ijin Pulang Awal</a-select-option>
            <a-select-option value="Ijin Tidak Masuk (Sakit)">Ijin Tidak Masuk (Sakit)</a-select-option>
            <a-select-option value="Ijin Tidak Masuk (Lain-Lain)">Ijin Tidak Masuk (Lain-Lain)</a-select-option>
            <!-- <a-select-option value="Perjalanan Dinas">Perjalanan Dinas</a-select-option> -->
          </a-select>
        </a-form-item>
        <a-form-item label="Keterangan">
          <a-textarea placeholder="Keterangan detil ijin ... " v-decorator="[
            'keterangan',
            {
              rules: [{ required: false }], initialValue: modal2.form.keterangan,
            },
          ]" class="w-full" />
        </a-form-item>
        <a-form-item v-if="modal2.EnableUploadDoc" label="Upload Document">
          <a-upload class="floating-button" :showUploadList="true" :fileList="push" :beforeUpload="beforeUpload"
            :remove="handleRemoveFile" v-decorator="[
              'upload',
              { rules: [{ required: true }] },
              { valuePropName: 'push' },
            ]">
            <a-button>
              <a-icon type="upload" />&nbsp;Select File
            </a-button>
          </a-upload>
        </a-form-item>
      </a-form>
    </a-modal>

    <a-modal v-model="modal3.visible" centered :width="isMobile ? '100%' : '40%'" :maskClosable="false"
      @cancel="handleCancelModalKet" @ok="handlePerijinan" :footer="false">
      <template slot="title">
        <h3>View Photo</h3>
      </template>
      <img :src="modal3.url" style="width: 100%;">
      <b>Keterangan</b> : {{ modal3.keterangan }}
    </a-modal>
  </a-card>
</template>

<script>
import axios from "axios";
import { mapGetters } from "vuex";
//import Grid from "@/components/AbsensiGrid.vue";
import moment from "moment";
import _ from "lodash";

const plainOptions = ["Gaji", "Value"];
const defaultCheckedList = [];

export default {
  name: "MonitoringAlokasiPekerjaan",
  props: ["spesialFor"],
  components: {
    //"H-AbsensiGrid": Grid,
  },
  data() {
    return {
      c: moment().format("DD"),
      datalist: [],
      datalist_origin: [],
      search: undefined,
      f_date: moment(),
      f_jns: "1",
      f_tlc: null,
      pagination: {
        page: 1,
        onChange: (page) => {
          this.pagination.page = page;
        },
        pageSize: 50,
        size: "default"
      },
      loading: {
        table: false,
        add: false
      },
      indeterminate: true,
      checkAll: false,
      plainOptions,
      checkedList: defaultCheckedList,
      referencedata: this.columns1,
      modal: {
        visible: false,
        title: 'Mocammad Zainal (MZA) - 01-09-2022',
        datalist: [],
        loading: false,
        total_jam: "",
      },
      modal2: {
        visible: false,
        EnableUploadDoc: false,
        loading: false,
        form: {
          tlc: "",
          jenis: "",
          keterangan: "",
        }
      },
      modal3: {
        visible: false,
        url: null,
      },
      push: [],
      jam_kerja: {
        krg_jam: 0,
        log_jam: 0,
        total_jam: 0,
      },
      formAbs:{
        sumber: "Aplikasi Harmoni",
        logTime: null,
        desc: null,
        tlc: null,
      },
      rulesAbs: {
        sumber: [
          {
            required: true,
            message: "Please input Sumber!",
            trigger: "change",
          },
        ],
        logTime: [
          {
            required: true,
            message: "Please input Log Time!",
            trigger: "change",
          },
        ],
        desc: [
          {
            required: true,
            message: "Please input Desc!",
            trigger: "change",
          },
        ],
      }
    };
  },
  computed: {
    ...mapGetters(["getAuth", "getDefaultDateFormat", "getStandartFormatDate", "getKaryawan", "getKaryawanBawahan"]),
    columns() {
      let { sortedInfo, filteredInfo } = this;
      sortedInfo = sortedInfo || {};
      filteredInfo = filteredInfo || {};
      const columns = [
        {
          title: 'No',
          scopedSlots: { customRender: "no" },
          width: 45,
          key: 'no',
          align: "right"
        },
        {
          key: 'tgl',
          title: 'Tanggal',
          width: 150,
          align: "left",
          scopedSlots: { customRender: "tgl" },
          sorter: (a, b) => b.tgl.localeCompare(a.tgl),
        },
        // {
        //   key: 'name',
        //   slots: { title: 'customTitle' },
        //   scopedSlots: { customRender: "name" },
        //   width:300,
        //   sorter: (a, b) => b.tlc.localeCompare(a.tlc),
        // },
        {
          title: 'Check  In',
          width: 120,
          key: 'check_in',
          align: "center",
          scopedSlots: { customRender: "check_in" },
          sorter: (a, b) => (b.check_in ? b.check_in : " ").localeCompare(a.check_in ? a.check_in : ""),
        },
        {
          title: 'Check  Out',
          width: 120,
          key: 'check_out',
          align: "center",
          scopedSlots: { customRender: "check_out" },
          sorter: (a, b) => (b.check_out ? b.check_out : " ").localeCompare(a.check_out ? a.check_out : ""),
        },
        {
          title: 'Total Jam',
          width: 200,
          dataIndex: 'total_jam',
          key: 'total_jam',
        },
        {
          title: 'Status',
          width: 200,
          dataIndex: 'status',
          key: 'status',
          sorter: (a, b) => (b.status ? b.status : " ").localeCompare(a.status ? a.status : ""),
        },
        {
          title: 'Keterangan',
          width: 450,
          key: 'keterangan',
          scopedSlots: { customRender: 'keterangan' },
        },
        {
          title: '#',
          width: 90,
          key: 'action',
          align: 'left',
          fixed: 'right',
          scopedSlots: { customRender: 'action' },
        },
      ];
      return columns;
    },
    columnsDtlLog() {
      const DtlLog = [
        {
          title: 'No',
          scopedSlots: { customRender: "dtlno" },
          key: 'no',
          width: 30,
          align: "center"
        },
        {
          title: 'Sumber',
          scopedSlots: { customRender: "sumber" },
          width: 200,
          key: 'sumber',
        },
        {
          title: 'Keterangan',
          scopedSlots: { customRender: "ket" },
          width: 140,
          key: 'ket',
        },
        {
          title: 'Cara',
          dataIndex: 'cara',
          width: 80,
          key: 'cara',
          align: "center"
        },
        {
          title: 'Log',
          scopedSlots: { customRender: "log" },
          width: 50,
          key: 'log',
          align: "center"
        },
      ];
      return DtlLog
    },
    f_date_start() {
      let startDate = moment(this.f_date).subtract(1, 'month');
      startDate = moment(startDate).endOf('month');
      return startDate.get('date') == 28 ?
        moment(this.f_date).add(-1, 'month').endOf('month').format("YYYY-MM-DD") :
        moment(startDate).set('date', 28).format("YYYY-MM-DD")
    },
    f_date_end() {
      let endDate = moment(this.f_date).endOf('month');
      //return moment().format('YYYY-MM') == moment(endDate).format('YYYY-MM') ?
      //moment().format('YYYY-MM-DD') : moment(endDate).set('date',27).format('YYYY-MM-DD')
      return moment(endDate).set('date', 27).format('YYYY-MM-DD')
    },
  },
  beforeCreate() {
    this.formKet = this.$form.createForm(this);
  },
  created() {
    this.$store.dispatch("FETCH_KARYAWAN");
    this.$store.dispatch("FETCH_KARYAWANBAWAHAN");
    //this.fetching();
  },
  methods: {
    moment,
    async fetching() {
      this.loading.table = true;
      await axios({
        method: "get",
        url: this.$serviceUrl + "absensi/log_kehadiran",
        params: {
          tlc: this.f_tlc,
          start_dt: moment(this.f_date_start, 'YYYY-MM-DD').format(this.getStandartFormatDate),
          end_dt: moment(this.f_date_end, 'YYYY-MM-DD').format(this.getStandartFormatDate),
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey,
        }
      })
        .then(response => {
          this.datalist_origin = response.data.data;
          this.jam_kerja.krg_jam = response.data.krg_jam;
          this.jam_kerja.log_jam = response.data.log_jam;
          this.jam_kerja.total_jam = response.data.total_jam;
          this.jam_kerja.hari_kerja = response.data.hari_kerja;
          this.jam_kerja.cuti = response.data.cuti;
          this.jam_kerja.ijin = response.data.ijin ? response.data.ijin : 0;
          //default daftar yang telah absensi
          this.f_jns = "1";
          this.searching();

          this.loading.table = false;
        })
        .catch(err => {
          this.loading.table = false;
          console.log(err.response);
        });
    },
    optionFilter(input, option) {
      return (
        option.componentOptions.children[0].text
          .toUpperCase()
          .indexOf(input.toUpperCase()) >= 0
      );
    },
    async kategoriChange() {
      this.loading.table = true;
      await this.searching();
      this.loading.table = false;
    },
    f_dateChange() {

      this.fetching();
    },
    getStyleRow(val, status, isi) {
      let result = '';

      if (val.length == 1) {
        if (status == 'Sudah Check Out') {
          result = 'row_hijau';
        }
      } else if (val.length > 1 && val.substring(0, 4) == 'Ijin') {
        result = 'row_kuning'
      } else if (val.length > 1 && val.substring(0, 9) == 'Terlambat') {
        result = 'row_merah'
      } else if (val.length > 1 && val.substring(0, 17) == 'Warning Terlambat') {
        result = 'row_krem'
      } else {
        result = ''
      }

      if (isi.total_jam_raw) {
        if (isi.total_jam_raw.substring(0, 2) == "08") {
          result = ''
        } else {
          result = 'row_merah'
        }
      }

      if (["Sabtu", "Minggu"].some(el => isi.hari.includes(el))) {
        result = 'row_abuabu'
      } else if (["Libur", "Cuti"].some(el => isi.status.includes(el))) {
        result = 'row_abuabu'
      }
      return result
    },
    searching() {
      // if(this.f_jns=="1"){
      //   this.datalist = _.filter( this.datalist_origin,
      //           (nav) => (nav.check_in!=null));
      // }else{
      //   this.datalist = _.filter( this.datalist_origin,
      //           (nav) => (nav.check_in==null));
      // }
      this.datalist = this.datalist_origin;
      if (this.search) {
        this.datalist = _.filter(
          this.datalist,
          (nav) => ((nav.tlc ? nav.tlc : "") + (nav.nama ? nav.nama : "") +
            (nav.keterangan ? nav.keterangan : "")).toLowerCase().indexOf(this.search.toLowerCase()) >= 0
        );
      }
    },
    handleExport(table, name) {
      this.loading.table = true;
      //this.onChange([]);
      setTimeout(() => {
        this.fireDownload(table, name);
        this.loading.table = false;
        //this.$router.go();
      }, 3000);
    },
    onChange(checkedList) {
      var _that = this;
      if (checkedList.length > 0) {
        //For individually selected functions
        this.indeterminate =
          !!checkedList.length && checkedList.length < plainOptions.length;
        this.checkAll = checkedList.length === plainOptions.length;
        //Just control the data rendering of checkedList
        //Modify the table data

        // console.log(this.columns)
        this.referencedata = JSON.parse(JSON.stringify(this.columns1)); //This treatment prevents the address from being passed
        let deletearray = JSON.parse(JSON.stringify(this.columns1));

        let targetValueList = checkedList.indexOf("Value");
        let targetGaji = checkedList.indexOf("Gaji");

        let valueList = [];

        let listcolumn = [];
        if (targetValueList >= 0) {
          valueList.forEach((item) => {
            listcolumn.push(item);
          });
        }

        if (targetGaji >= 0) {
          listcolumn.push("Gaji");
        }

        checkedList.forEach((item) => {
          if (item == "Gaji") {
            for (let i = 0; i < deletearray.length; i++) {
              if (item == deletearray[i].title || item == deletearray[i]) {
                deletearray.splice(i, 1);
                _that.referencedata = deletearray;
              }
            }
          }
          if (item == "Value") {
            for (let i = 0; i < deletearray.length; i++) {
              if (deletearray[i].title == "Kode Proyek") {
                const child = deletearray[i].children;
                for (let a = 0; a < child.length; a++) {
                  child[a].children.pop();
                  _that.referencedata = deletearray;
                }
              }
            }
          }
        });
      } else {
        _that.referencedata = this.columns1;
      }
    },
    fireDownload(table, name) {
      let uri = "data:application/vnd.ms-excel;base64,",
        template =
          '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--><meta http-equiv="content-type" content="text/plain; charset=UTF-8"/><style>table, td {border:thin solid black}table {border-collapse:collapse}</style></head><body><table>{table}</table></body></html>',
        base64 = function (s) {
          return window.btoa(unescape(encodeURIComponent(s)));
        },
        format = function (s, c) {
          return s.replace(/{(\w+)}/g, function (m, p) {
            return c[p];
          });
        };
      if (!table.nodeType) table = document.getElementsByClassName("contentTable");

      let sourceHTML = table[0].innerHTML;

      //replace to change color background
      sourceHTML = sourceHTML.replaceAll('class="ant-table-row ant-table-row-level-0 row_hijau"', 'style="background-color:#d3f897"');
      sourceHTML = sourceHTML.replaceAll('class="ant-table-row ant-table-row-level-0 row_kuning"', 'style="background-color:#ffe08f"');
      sourceHTML = sourceHTML.replaceAll('class="ant-table-row ant-table-row-level-0 row_merah"', 'style="background-color:#ea8c8c"');
      sourceHTML = sourceHTML.replaceAll('class="ant-table-row ant-table-row-level-0 row_krem"', 'style="background-color:#fcffb2"');

      let ctx = { worksheet: name || "Worksheet", table: sourceHTML };
      let a = document.createElement("a");
      a.href = uri + base64(format(template, ctx));
      a.download = "Absensi_" + moment().format('YYYY-MM-DD') + ".xls";
      a.click();
    },
    handleshowModal(item) {
      //console.log(item)
      this.modal.title = item.nama + " (" + item.tlc + ") [" + moment(item.tgl, 'YYYY-MM-DD').format('DD-MM-YYYY') + "]";
      this.formAbs.tlc = item.tlc
      this.formAbs.logDay = moment(item.tgl, 'YYYY-MM-DD').set({hour:0,minute:0,second:0,millisecond:0})
      this.formAbs.logTime = moment(item.tgl, 'YYYY-MM-DD').set({hour:0,minute:0,second:0,millisecond:0})
      this.modal.visible = true;
      this.modal.loading = true;
      axios({
        method: "get",
        url: this.$serviceUrl + "absensi/log_absen",
        params: {
          "X-API-KEY": this.getAuth.apikey,
          tlc: item.tlc,
          tgl: item.tgl,
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password
        }
      })
        .then(response => {
          this.modal.datalist = response.data.dtl;
          this.modal.total_jam = response.data.total_jam;
          this.modal.loading = false;
        })
        .catch(err => {
          this.modal.loading = false;
          console.log(err.response);
        });
    },
    handleCancel() {
      this.modal.visible = false;
    },
    handleModalKet(val) {
      this.modal2.visible = true;
      this.modal2.tlc = val.tlc;
      this.modal2.tgl = val.tgl;
      this.modal2.perijinan_id = val.perijinan_id;
      this.modal2.form.jenis = val.jenis_keterangan;
      this.modal2.form.keterangan = val.keterangan_ijin;
      this.modal2.form.tlc = val.tlc;
    },
    handleCancelModalKet() {
      this.modal2.visible = false;
      this.modal2.form.jenis = null;
      this.modal2.form.keterangan = null;
      this.modal2.form.tlc = null;
    },
    beforeUpload(file) {
      this.push = [];
      this.push.push(file);
      return false;
    },
    HandleChangeJenis(val) {
      if (val == 'Ijin Tidak Masuk (Sakit)' || val == 'Ijin Tidak Masuk (Lain-Lain)' || val == 'Ijin Terlambat' || val == 'Ijin Pulang Awal') {
        this.modal2.EnableUploadDoc = true;
      } else {
        this.modal2.EnableUploadDoc = false;
        this.push = [];
      }
    },
    handleRemoveFile() {
      this.push = [];
    },
    handlePerijinan(item) {
      this.formKet.validateFields((err, values) => {
        if (err) {
          this.displayMessage("form-warning");
          return;
        }

        let data = new FormData();
        data.append("X-API-KEY", this.getAuth.apikey);
        data.append("tlc", this.modal2.tlc);
        data.append("tgl", this.modal2.tgl);
        data.append("jenis", values.jenis);
        data.append("perijinan_id", this.modal2.perijinan_id);
        data.append("keterangan", values.keterangan ? values.keterangan : "");
        data.append("hrd_sts", values.hrd_sts ? values.hrd_sts : "");
        data.append("hrd_ket", values.hrd_ket ? values.hrd_ket : "");

        if (values.jenis == 'Ijin Tidak Masuk (Sakit)' || values.jenis == 'Ijin Tidak Masuk (Lain-Lain)' || values.jenis == 'Ijin Terlambat' || values.jenis == 'Ijin Pulang Awal') {
          data.append("file_upload", this.push[0]);
        }

        this.modal2.loading = true;
        axios({
          method: "post",
          url: this.$serviceUrl + (this.modal2.perijinan_id ? "absensi/perijinan_edit" : "absensi/perijinan"),
          data: data,
          auth: {
            username: this.getAuth.username,
            password: this.getAuth.password
          }
        })
          .then(response => {
            // this.modal.datalist = response.data.dtl;
            // this.modal.total_jam = response.data.total_jam;
            // this.modal.loading = false;
            this.modal2.visible = false;
            this.modal2.loading = false;
            this.modal2.form.jenis = null;
            this.modal2.form.keterangan = null;
            this.modal2.form.tlc = null;
            this.push = [];
            this.fetching();
          })
          .catch(err => {
            err = Object.assign({}, err.response)
            if (err.data.message) {
              this.displayMessageValue("error-basic", err.data.message);
            } else {
              this.displayMessageValue("error-other", err);
            }
            this.modal2.loading = false;
            console.log(err.response);
          });
      });
    },
    handleViewfile(url) {
      window.open(this.$serviceUrl + url, "_blank");
    },
    handleCloseModalHist() {
      this.modal.datalist = [];
      this.fetching();
    },
    viewPhoto(url, note) {
      this.modal3.visible = true;
      this.modal3.url = this.$serviceUrl + url;
      this.modal3.keterangan = note;
      // window.open(this.$serviceUrl+url, "_blank");
    },
    viewGoogleMaps(lat, long) {
      window.open("https://www.google.com/maps/search/" + lat + "++" + long, "_blank");
    },
    handleshowFile(path) {
      window.open(this.$serviceUrl + path, "_blank");
    },
    addLog(){
      this.$refs.forms.validate((valid) => {
        if (!valid) {
          this.displayMessage("form-warning");
          return;
        }
        
        const payload = new FormData()
        payload.append("tlc", this.formAbs.tlc)

        payload.append("log_time", moment(this.formAbs.logTime).format('YYYY-MM-DD HH:mm:ss'))
        payload.append("keterangan", this.formAbs.desc?this.formAbs.desc:0)

        this.loading.add = true
        this.asyncAxiosPost("absensi/entri", "formdata", this.getAuth, payload)
        .then(async () => {
          this.formAbs.logTime = moment(this.formAbs.logDay).set({hour:0,minute:0,second:0,millisecond:0})
          this.formAbs.desc = null

            await axios({
            method: "get",
            url: this.$serviceUrl + "absensi/log_absen",
            params: {
              "X-API-KEY": this.getAuth.apikey,
              tlc: this.formAbs.tlc,
              tgl: moment(this.formAbs.logTime).format('YYYY-MM-DD'),
            },
            auth: {
              username: this.getAuth.username,
              password: this.getAuth.password
            }
          })
            .then(response => {
              this.modal.datalist = response.data.dtl;
              this.modal.total_jam = response.data.total_jam;
              this.modal.loading = false;
            })
            .catch(err => {
              this.modal.loading = false;
              console.log(err.response);
            });

          this.loading.add = false
        })
        .catch(err => {
          this.loading.add = false
          console.log(err);
        });
      })
    }
  },
  mounted() {
    this.f_date = parseInt(moment().format("DD")) > 27 ? moment().add(1, 'M') : moment();
    this.f_tlc = this.f_tlc ? this.f_tlc : this.getAuth.username;
    this.fetching();
  },
  activated() {
  },
  watch: {
    search() {
      this.searching();
    },
  },
};
</script>

<style lang="less">
.col_hidden {
  display: none;
}

.act-grid {
  padding-top: 0px;
}

.content-filter {
  margin-top: 12px;
  padding: 10px;
  background-color: fade(@primary-color, 55%);
  border-radius: 3px;
}

.row_merah {
  background-color: fade(#d00000, 45%) !important;

}

.row_krem {
  background-color: #FCFFB2 !important;
}

.row_kuning {
  background-color: fade(#ffba08, 45%) !important;
}

.row_hijau {
  background-color: fade(#9ef01a, 45%) !important;
}

.row_abuabu {
  background-color: fade(#070a01, 25%) !important;
}

.ant-table-thead {
  background-color: @primary-color !important;

  th {
    text-align: center !important;
    color: rgb(255 255 255) !important;
    font-weight: bold !important;
  }
}

.contentTable {
  display: none
}

.ant-table-tbody>tr.row_merah>td.ant-table-column-sort {
  background-color: #ea8c8c;
}

.ant-table-tbody>tr.row_krem>td.ant-table-column-sort {
  background-color: #fcffb2;
}

.ant-table-tbody>tr.row_kuning>td.ant-table-column-sort {
  background-color: #ffe08f;
}

.ant-table-tbody>tr.row_hijau>td.ant-table-column-sort {
  background-color: #d3f897;
}

.ant-table-small>.ant-table-content>.ant-table-body {
  margin: 0 0 !important;
}
</style>
